import { Injectable } from '@angular/core';
import { EEndpointMethod, RESTGeneratorService } from './rest-generator.service';

@Injectable({
  providedIn: 'root',
})
export class ModuleColourService {
  readonly restFuncs = this.restGenS.generateRESTFunctions({
    saveColourCode: { route: `galaxy/colour/codes`, method: EEndpointMethod.post },
    searchColourCodes: {
      route: `galaxy/colour/codes/search`,
      method: EEndpointMethod.get,
    },
  });
  constructor(protected restGenS: RESTGeneratorService) {}
}
